import { targetAcosEnabled } from '@/config/targetAcos.js';

const TARGET_ACOS_PATHS = ['/settings/targets', '/ppc/performance-targets'];

export const isTargetAcosPathBlocked = (path) => {
  const normalized = path.toLowerCase();
  return !targetAcosEnabled && TARGET_ACOS_PATHS.some(
    (item) => normalized === item || normalized.startsWith(`${item}/`),
  );
};
